(function() {
    'use strict';

    const VARIANT_CONFIG = {
        3: { tickers: 3, keywords: ['3 informes', '3 tickers'] },
        5: { tickers: 5, keywords: ['5 informes', '5 tickers'] },
        10: { tickers: 10, keywords: ['10 informes', '10 tickers'] },
        20: { tickers: 20, keywords: ['20 informes', '20 tickers'] }
    };

    // Clase para manejar cada instancia de ticker fields
    class TickerFieldsManager {
        constructor(wrapper) {
            this.wrapper = wrapper;
            this.container = wrapper.querySelector('.ticker-fields') || wrapper.querySelector('#ticker-fields-container');
            if (!this.container) return;

            this.currentRequiredCount = 3;
            this.section = wrapper.closest('[data-section]') || wrapper.closest('section') || document;

            this.init();
        }

        init() {
            this.observeVariantChanges();
            this.setupInputListeners();
            this.updateTickerFields();
            this.setupFormValidation();
            this.updateProgress();
        }

        observeVariantChanges() {
            // Escuchar cambios en radio buttons dentro de la sección
            this.section.querySelectorAll('input[type="radio"]').forEach(input => {
                input.addEventListener('change', () => {
                    this.updateTickerFields();
                    this.updateProgress();
                });
            });

            // Escuchar cambios en selects dentro de la sección
            this.section.querySelectorAll('select').forEach(select => {
                select.addEventListener('change', () => {
                    this.updateTickerFields();
                    this.updateProgress();
                });
            });

            // Escuchar evento personalizado de Shopify
            document.addEventListener('variant:change', () => {
                this.updateTickerFields();
                this.updateProgress();
            });

            // Observer para cambios en el DOM (por si el tema usa AJAX)
            const priceWrapper = this.section.querySelector('.price-wrapper, .product-subscription__price');
            if (priceWrapper) {
                const observer = new MutationObserver(() => {
                    this.updateTickerFields();
                    this.updateProgress();
                });
                observer.observe(priceWrapper, { childList: true, subtree: true });
            }
        }

        setupInputListeners() {
            this.wrapper.querySelectorAll('.ticker-field__input').forEach(input => {
                // Actualizar progreso al escribir
                input.addEventListener('input', () => {
                    // Convertir a mayúsculas mientras escribe
                    input.value = input.value.toUpperCase();

                    // Marcar como válido si tiene contenido
                    if (input.value.trim()) {
                        input.classList.add('is-filled');
                    } else {
                        input.classList.remove('is-filled');
                    }

                    this.updateProgress();
                });

                // Limpiar espacios al perder foco
                input.addEventListener('change', () => {
                    input.value = input.value.trim().toUpperCase();
                });
            });
        }

        getCurrentVariantCount() {
            // Buscar el texto de la variante seleccionada dentro de la sección
            let variantText = '';

            // Método 1: Radio buttons
            const checkedRadio = this.section.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                variantText = checkedRadio.value.toLowerCase();
            }

            // Método 2: Select dropdown
            const variantSelect = this.section.querySelector('select[name="id"], select.product-form__input, select.select__select');
            if (variantSelect && variantSelect.selectedOptions[0]) {
                variantText = variantSelect.selectedOptions[0].textContent.toLowerCase();
            }

            // Método 3: Buscar en labels o elementos seleccionados
            const selectedLabel = this.section.querySelector('.product-form__input input:checked + label, .product-subscription__variant-btn');
            if (selectedLabel) {
                const checkedInput = this.section.querySelector('input[type="radio"]:checked + .product-subscription__variant-btn');
                if (checkedInput) {
                    variantText += ' ' + checkedInput.textContent.toLowerCase();
                } else if (selectedLabel) {
                    variantText += ' ' + selectedLabel.textContent.toLowerCase();
                }
            }

            // Determinar qué variante es
            for (const [count, config] of Object.entries(VARIANT_CONFIG).reverse()) {
                for (const keyword of config.keywords) {
                    if (variantText.includes(keyword.toLowerCase())) {
                        return parseInt(count);
                    }
                }
            }

            // Buscar números en el texto como fallback
            const numbers = variantText.match(/\b(3|5|10|20)\b/);
            if (numbers) {
                return parseInt(numbers[0]);
            }

            // Default: 3 tickers
            return 3;
        }

        updateTickerFields() {
            this.currentRequiredCount = this.getCurrentVariantCount();
            const fields = this.wrapper.querySelectorAll('.ticker-field');
            const requiredCounter = this.wrapper.querySelector('#tickers-required-count, [id$="tickers-required-count"]');
            const tickerContainer = this.wrapper.querySelector('.ticker-fields');

            fields.forEach(field => {
                const index = parseInt(field.dataset.tickerIndex);
                const minVariant = parseInt(field.dataset.minVariant);
                const input = field.querySelector('input');

                if (index <= this.currentRequiredCount) {
                    field.style.display = 'flex';
                    input.disabled = false;
                } else {
                    field.style.display = 'none';
                    input.disabled = true;
                    input.value = '';
                    input.classList.remove('is-valid', 'is-invalid');
                }
            });

            // Actualizar contador requerido
            if (requiredCounter) {
                requiredCounter.textContent = this.currentRequiredCount;
            }

            // Añadir clase para layout de columnas cuando hay muchos tickers
            if (tickerContainer) {
                tickerContainer.classList.remove('ticker-fields--four-columns', 'ticker-fields--two-columns', 'ticker-fields--many');
                if (this.currentRequiredCount >= 20) {
                    tickerContainer.classList.add('ticker-fields--four-columns');
                } else if (this.currentRequiredCount >= 10) {
                    tickerContainer.classList.add('ticker-fields--two-columns');
                } else if (this.currentRequiredCount >= 5) {
                    tickerContainer.classList.add('ticker-fields--many');
                }
            }
        }

        updateProgress() {
            const visibleInputs = this.getVisibleInputs();
            const filledInputs = visibleInputs.filter(input => input.value.trim() !== '');

            const filledCount = filledInputs.length;
            const totalCount = visibleInputs.length;
            const percentage = totalCount > 0 ? (filledCount / totalCount) * 100 : 0;
            const isComplete = filledCount === totalCount && totalCount > 0;

            // Actualizar contador
            const filledCounter = this.wrapper.querySelector('#tickers-filled-count, [id$="tickers-filled-count"]');
            const requiredCounter = this.wrapper.querySelector('#tickers-required-count, [id$="tickers-required-count"]');
            if (filledCounter) filledCounter.textContent = filledCount;
            if (requiredCounter) requiredCounter.textContent = totalCount;

            // Actualizar barra de progreso
            const progressBar = this.wrapper.querySelector('#ticker-progress-bar, [id$="ticker-progress-bar"]');
            if (progressBar) {
                progressBar.style.width = percentage + '%';
                progressBar.classList.toggle('is-complete', isComplete);
            }

            // Mostrar mensaje de éxito cuando todos están completos (informativo)
            const successMessage = this.wrapper.querySelector('#ticker-success, [id$="ticker-success"]');
            if (successMessage) {
                successMessage.style.display = isComplete ? 'flex' : 'none';
            }
        }

        getVisibleInputs() {
            return Array.from(this.wrapper.querySelectorAll('.ticker-field')).filter(field => {
                return field.style.display !== 'none' && !field.querySelector('input').disabled;
            }).map(field => field.querySelector('input'));
        }

        setupFormValidation() {
            // Buscar el formulario asociado a este wrapper
            const form = this.section.querySelector('form[action*="/cart/add"]');
            if (!form) return;

            // Solo limpiar y formatear los valores al enviar, sin bloquear
            form.addEventListener('submit', () => {
                const visibleInputs = this.getVisibleInputs();
                visibleInputs.forEach(input => {
                    input.value = input.value.trim().toUpperCase();
                });
            });
        }
    }

    // Almacenar instancias
    const instances = new Map();

    function init() {
        // Buscar todos los wrappers de ticker fields
        const wrappers = document.querySelectorAll('.ticker-fields-wrapper');

        wrappers.forEach(wrapper => {
            if (!instances.has(wrapper)) {
                const instance = new TickerFieldsManager(wrapper);
                instances.set(wrapper, instance);
            }
        });
    }

    // Iniciar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Re-inicializar si se cargan nuevas secciones (Shopify theme editor)
    document.addEventListener('shopify:section:load', init);
})();